<template>
    <div class="anb">
        <div class="anb__inner">
            <div class="anb__title">
                Allgemeine Nutzungsbedingungen
            </div>

            <div class="anb__content" v-html="anb">
                {{anb}}
            </div>

            <default-button class="anb__button" @click="sendAsMail()">Als E-Mail senden</default-button>
        </div>
    </div>
</template>

<script>
import DefaultButton from '../common/default-button';

export default {
    components: {
        DefaultButton
    },
    computed: {
        anb() {
            return this.$store.getters['user/anb'];
        }
    },
    methods: {
        sendAsMail() {
            this.$store.dispatch('user/sendMailToId', {
                subject: 'Allgemeine Nutzungsbedingungen',
                body: 'Hallo,<br>' +
                    'Hier sind die ANB\'s<br><br><hr>' +
                    this.anb +
                    '<hr> <br> '
            });
        }
    },
    created() {
        this.$store.dispatch('user/anb');
    }
}
</script>

<style scoped lang="scss">
.anb{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: $color-white;

}

.anb__inner{
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0.625rem;
    height: 90vh;

    @include medium {
        width: 31rem;
    }

    @include extra-large {
        width: 700px;
    }
}

.anb__title{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    background-color: $color-gray;
    color: $color-white;

}

.anb__content{
    flex:1;
    overflow-y: scroll;
    padding: 0.625rem;
    font-size: 1.25rem;
}
</style>
